import KKCA from "../../../../../components/categories/siakad/laporan_adab/kkca/Home";
export default function Home() {
  
  return (
    <KKCA />
  );
}
